
export function feconIsacConfig ($httpProvider, feconIsacConfigProvider) {
    'ngInject';

    // session expired interceptor
    $httpProvider.interceptors.push('feconIsacSessionExpiredHttpInterceptor');

    /*
       Nome della property (sulla definizione degli stati del router) controllata da feconIsac
       per determinare se lo stato richiede che l'utente sia autenticato (default: 'authRequired')
    */
    feconIsacConfigProvider.set('authenticationRequired.stateDataPropertyName', 'authRequired');


    // Header addizionali che inibiscono l'intervento dell'interceptor session expired
    //feconIsacConfigProvider.get('sessionExpiredHttpInterceptor.additionalExclusionHeaders').push({ name: 'x-additional', value: 'x' });


    // Comportamento fun isac "forceEmail" (invio email con token per la forzatura della password)
    /*
       OPT1 (default): la chiamata all'api di back-end prodotto viene effettuata direttamente da isac verso il path specificato
       @note se OPT2 è abilitata, questa property viene ignorata
    */
    feconIsacConfigProvider.set('credentialsRecovery.sendEmail.productApiPath', '/product-api/force-email');

    /*
       OPT2: integrationDelegate si occupa di effettuare la chiamata all'api di back-end del prodotto
       @note abilitando questa opzione, fecon-isac invoca il metodo asyncExecuteSendEmailForCredentialsRecovery sul servizio integrationDelegate
    */
    //feconIsacConfigProvider.set('credentialsRecovery.sendEmail.delegateApiCallToProductIntegration', true);


    /*
       Delegato dell'integrazione fecon-isac con questa specifica Applicazione
    */
    feconIsacConfigProvider.set('integrationDelegate', 'ProductFeconIsacIntegrationDelegate');

}



// WEBPACK FOOTER //
// ./client/app/app.config/isac.config.js